import React, { useState, useEffect, useCallback } from "react";
import AppointmentSettingsCard from "../../../../components/appointmentSettingsCard";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchServiceCategory,
  fetchService,
} from "../../../../store/slices/serviceSlice";
import { Pagination, Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { deleteDealCard } from "../../../../api/settings";

const AppointmentSettings = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(3);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [render, setRender] = useState(false);
  const dispatch = useDispatch();
  // const text = useSelector((state) => state?.text?.value);
  const serviceValue = useSelector((state) => state?.service);
  const getService = serviceValue?.value?.service;
  const getServiceCategories = useCallback(async () => {
    dispatch(fetchServiceCategory());
  }, [dispatch]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };
  const payload = {
    pageNumber: currentPage,
    pageSize: pageSize,
    // text: text || null,
  };

  const hideModal = () => {
    setIsModalOpen(false);
  };

  const YesClickHandler = async () => {
    setIsModalOpen(false);
    try {
      const res = await deleteDealCard(deleteId);
      if (res) {
        message.success("Service Card Deleted!");
        setRender(!render);
      }
    } catch (error) {
      message.error("Error in Deleting Deal Card");
    }
  };
  const showModal = (id) => {
    setIsModalOpen(true);
    setDeleteId(id);
  };
  useEffect(() => {
    dispatch(fetchService(payload));
    getServiceCategories();
  }, [dispatch, render, getServiceCategories, pageSize, currentPage]);
  if (serviceValue?.isLoading && serviceValue?.isLoadingCategory) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spin
          indicator={<LoadingOutlined />}
          className="flex justify-center"
          size="large"
        />
      </div>
    );
  }
  if (!getService?.totalItems) {
    return (
      <div className="flex justify-center opacity-50 mt-20">
        <h1 className="text-xl flex justify-center mr-2 mt-0.4">
          No Appointments Yet
        </h1>
      </div>
    );
  }

  return (
    <>
      <div className={`relative ${isModalOpen ? "blur-sm" : ""}`}>
        <div className="m-3">
          <div className="mb-4">
            {getService?.items?.map((data, i) => {
              return (
                <div className="mb-2" key={i}>
                  <AppointmentSettingsCard
                    data={data}
                    showModal={() => showModal(data?._id)}
                  />
                </div>
              );
            })}
          </div>
          <div className="flex justify-center items-center pagination-container mb-2">
            <Pagination
              current={currentPage}
              total={getService?.totalItems}
              pageSize={pageSize}
              pageSizeOptions={[3, 10, 20, 30]}
              onShowSizeChange={handleSizeChange}
              onChange={(e) => {
                handlePageChange(e);
              }}
            />
          </div>
        </div>
        {isModalOpen && (
          <DeleteMemberModal
            title="Delete Service Card"
            text="Do you want to Delete Service Card?"
            onCancel={hideModal}
            onOk={YesClickHandler}
          />
        )}
      </div>
    </>
  );
};

export default AppointmentSettings;
